// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Motion$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Motion.res.mjs";
import * as StimulusTabContext$LiteracyplanetTupperware from "./StimulusTabContext.res.mjs";

function PilotStimulusTabContent(props) {
  var showing = StimulusTabContext$LiteracyplanetTupperware.useTabContent(props.tab);
  return React.createElement(Motion$LiteracyplanetClientFlags.Div.make, {
              initial: {
                filter: "blur(10px)"
              },
              animate: {
                filter: "none"
              },
              className: showing ? "" : "hidden",
              children: Caml_option.some(props.children)
            });
}

var Motion;

var make = PilotStimulusTabContent;

var $$default = PilotStimulusTabContent;

export {
  Motion ,
  make ,
  $$default as default,
}
/* react Not a pure module */
